import { render, staticRenderFns } from "./stopjiangpei.vue?vue&type=template&id=a4365ea2"
import script from "./stopjiangpei.vue?vue&type=script&lang=js"
export * from "./stopjiangpei.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports